import request from '../utils/request.js'

export default {
	projectStatistics(params) {
		return request.post(`statistics/project_statistics`, params).then(res => res.data);
	},
	projectStatisticsChart1(params) {
		return request.post(`statistics/chart1`, params).then(res => res.data);
	},
	projectStatisticsChart2(params) {
		return request.post(`statistics/chart2`, params).then(res => res.data);
	},
	jobsStatistics(params) {
		return request.post(`statistics/jobs`, params).then(res => res.data);
	},

}


// WEBPACK FOOTER //
// ./src/api/statistics.js